import React from 'react';
import { useTranslation } from 'react-i18next';

import { ArrowLeftIcon } from '../icons';
import { useCustomizer } from '../../store/customizer';
import { Bar, Left, BackButton, Title } from './WizardHeader.styles';

/**
 * Desktop wizard header — a back button + the "Step N: <name>" title. Shared
 * chrome across steps. The back button steps the wizard back (the same
 * "arrow-left" glyph the drill-in detail pages use) and is hidden on step 1,
 * where there is nothing to go back to. In the connect-domain sub-flow the title
 * swaps to "Link your own domain" (the records screen names the chosen casino).
 */
export const WizardHeader = (): React.ReactElement => {
  const { t } = useTranslation();
  const { step, steps, stepKey, connectStage, selectedName, goBack } = useCustomizer();
  const current = steps.find((s) => s.key === stepKey) ?? steps[0];

  // The step names on the store are stable English ids (fixed UI vocabulary);
  // translate at render time so the title localizes and re-evaluates on language
  // change. Unknown ids fall back to the English id.
  const stepNames: Record<string, string> = {
    'Operating Area': t('Operating Area'),
    'Website Name': t('Website Name'),
    Logo: t('Logo'),
    'Go live': t('Go live'),
  };
  const currentName = stepNames[current.name] ?? current.name;

  return (
    <Bar>
      <Left>
        {step > 1 ? (
          <BackButton type="button" aria-label={t('Back')} onClick={goBack}>
            <ArrowLeftIcon size={18} />
          </BackButton>
        ) : null}
        {connectStage === 'dns' && selectedName ? (
          <Title text="Link your own domain to {{brand}} casino" placeholders={{ brand: selectedName }} tag="h1" />
        ) : connectStage ? (
          <Title text="Link your own domain" tag="h1" />
        ) : (
          <Title text="Step {{n}}: {{name}}" placeholders={{ n: step, name: currentName }} tag="h1" />
        )}
      </Left>
    </Bar>
  );
};

export default WizardHeader;